import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { Component } from 'react';

import Slider from 'react-slick';
import classes from './SlickSlider.module.scss';

import firstSlide from '../../../assets/images/slider/first-slide.webp';
import secondSlide from '../../../assets/images/slider/second-slide.webp';
import thirdSlide from '../../../assets/images/slider/third-slide.webp';
export default class SlickSlider extends Component {
    render() {
        const settings = {
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
            autoplaySpeed: 5000,
            lazyLoad: true,
        };

        return (
            <div className={classes.Slick}>
                <Slider {...settings}>
                    <div>
                        <div
                            className="background-image"
                            style={{
                                backgroundImage: `url(${firstSlide})`,
                                backgroundPosition: 'center',
                            }}
                        >
                            <div>
                                <h2>Celebrate Life - Manage Death</h2>
                                <p>
                                    Aura is a safe, simple space to leave
                                    important information on life's affairs, say
                                    the things that matter most and celebrate
                                    your life with loved ones.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="background-image"
                            style={{
                                backgroundImage: `url(${secondSlide})`,
                                backgroundPosition: 'center',
                            }}
                        >
                            <div>
                                <h2>
                                    Provide your family with the Practical
                                    Information on things that matter most.
                                </h2>
                                <p>
                                    This is a great place to keep your life
                                    affairs properly managed - think of it as an
                                    online filing cabinet.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="background-image"
                            style={{
                                backgroundImage: `url(${thirdSlide})`,
                                backgroundPosition: 'center',
                            }}
                        >
                            <div>
                                <h2>
                                    Take control of your end of life - let your
                                    Wishes be known.
                                </h2>
                                <p>
                                    There’s many decisions to be made, from
                                    advance care planning to funeral wishes,
                                    giving you peace of mind and your family the
                                    space to grieve properly.
                                </p>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        );
    }
}
